export default __webpack_public_path__ + "static/media/icon-loader.fdd80e02.svg";